import { Scenario, ScenarioType, Steps, HostName } from '../state/interfaces'
import {
  buyOrBringPhone,
  chooseBrands,
  chooseBrandsAndroid,
  chooseBrandsProprietary,
  choosePhoneCamera,
  choosePhoneFromList,
  choosePhoneMemory,
  choosePhoneOs,
  choosePhoneSize,
  currentProviderMobile,
  howManyCallingMinutes,
  howManyCallingMinutesC,
  howMuchData,
  howMuchDataC,
  provincesStep,
  bigEnterprise,
  sliderData,
  howMuchDataB,
  buyOrBringPhoneD,
  emailAddressMobile,
  howManyCallingMinutesE,
  howManyCallingMinutesF,
  callingOptions,
  sliderDataG,
  coverage,
  chooseWifiCalling,
  bigEnterprise2,
  provincesStepI,
  businessOrNotMobile,
  choosePhoneSizeO,
  currentProviderInternetMobile,
  howMuchDataD,
  androidApp,
} from './mobile-steps'

export const mobileScenarioA: Scenario = {
  id: 'mobile-a',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.MOBILE,
  version: '1',
  milestones: [
    provincesStep.id,
    currentProviderMobile.id,
    howManyCallingMinutes.id,
    howMuchData.id,
    buyOrBringPhone.id,
    choosePhoneOs.id,
    chooseBrands.id,
    choosePhoneSize.id,
    choosePhoneCamera.id,
    choosePhoneMemory.id,
    choosePhoneFromList.id,
  ],
  steps: [
    provincesStep,
    currentProviderMobile,
    howManyCallingMinutes,
    howMuchData,
    buyOrBringPhone,
    choosePhoneOs,
    chooseBrands,
    chooseBrandsAndroid,
    chooseBrandsProprietary,
    choosePhoneSize,
    choosePhoneCamera,
    choosePhoneMemory,
    choosePhoneFromList,
  ],
  weight: 0,
}

export const mobileScenarioB: Scenario = {
  id: 'mobile-b',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.MOBILE,
  version: '1',
  milestones: [
    provincesStep.id,
    currentProviderMobile.id,
    howManyCallingMinutes.id,
    howMuchDataB.id,
    bigEnterprise.id,
    buyOrBringPhone.id,
    choosePhoneOs.id,
    chooseBrands.id,
    choosePhoneSize.id,
    choosePhoneCamera.id,
    choosePhoneMemory.id,
    choosePhoneFromList.id,
  ],
  steps: [
    provincesStep,
    currentProviderMobile,
    howManyCallingMinutes,
    howMuchDataB,
    bigEnterprise,
    buyOrBringPhone,
    choosePhoneOs,
    chooseBrands,
    chooseBrandsAndroid,
    chooseBrandsProprietary,
    choosePhoneSize,
    choosePhoneCamera,
    choosePhoneMemory,
    choosePhoneFromList,
  ],
  weight: 0,
}

export const mobileScenarioC: Scenario = {
  id: 'mobile-c',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.MOBILE,
  version: '1',
  milestones: [
    provincesStep.id,
    currentProviderMobile.id,
    howManyCallingMinutesC.id,
    howMuchDataC.id,
    bigEnterprise.id,
    buyOrBringPhone.id,
    choosePhoneOs.id,
    chooseBrands.id,
    choosePhoneSize.id,
    choosePhoneCamera.id,
    choosePhoneMemory.id,
    choosePhoneFromList.id,
  ],
  steps: [
    provincesStep,
    currentProviderMobile,
    howManyCallingMinutesC,
    howMuchDataC,
    sliderData,
    bigEnterprise,
    buyOrBringPhone,
    choosePhoneOs,
    chooseBrands,
    chooseBrandsAndroid,
    chooseBrandsProprietary,
    choosePhoneSize,
    choosePhoneCamera,
    choosePhoneMemory,
    choosePhoneFromList,
  ],
  weight: 0,
}

export const mobileScenarioD: Scenario = {
  id: 'mobile-d',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.MOBILE,
  version: '1',
  milestones: [
    provincesStep.id,
    currentProviderMobile.id,
    howManyCallingMinutes.id,
    howMuchData.id,
    buyOrBringPhoneD.id,
    choosePhoneOs.id,
    chooseBrands.id,
    choosePhoneSize.id,
    choosePhoneCamera.id,
    choosePhoneMemory.id,
    choosePhoneFromList.id,
    emailAddressMobile.id,
  ],
  steps: [
    provincesStep,
    currentProviderMobile,
    howManyCallingMinutes,
    howMuchData,
    buyOrBringPhoneD,
    choosePhoneOs,
    chooseBrands,
    chooseBrandsAndroid,
    chooseBrandsProprietary,
    choosePhoneSize,
    choosePhoneCamera,
    choosePhoneMemory,
    choosePhoneFromList,
    emailAddressMobile,
  ],
  weight: 0,
  restrictions: [HostName.PLANHUB, HostName.LOCALHOST],
}

export const mobileScenarioE: Scenario = {
  id: 'mobile-e',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.MOBILE,
  version: '1',
  milestones: [
    provincesStep.id,
    currentProviderMobile.id,
    howManyCallingMinutesE.id,
    callingOptions.id, // if reactivated check calling options existence
    howMuchDataC.id,
    bigEnterprise.id,
    buyOrBringPhone.id,
    choosePhoneOs.id,
    chooseBrands.id,
    choosePhoneSize.id,
    choosePhoneCamera.id,
    choosePhoneMemory.id,
    choosePhoneFromList.id,
  ],
  steps: [
    provincesStep,
    currentProviderMobile,
    howManyCallingMinutesE,
    callingOptions, // if reactivated check calling options existence
    howMuchDataC,
    sliderData,
    bigEnterprise,
    buyOrBringPhone,
    choosePhoneOs,
    chooseBrands,
    chooseBrandsAndroid,
    chooseBrandsProprietary,
    choosePhoneSize,
    choosePhoneCamera,
    choosePhoneMemory,
    choosePhoneFromList,
  ],
  weight: 0,
}

export const mobileScenarioF: Scenario = {
  id: 'mobile-f',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.MOBILE,
  version: '1',
  milestones: [
    provincesStep.id,
    currentProviderMobile.id,
    howManyCallingMinutesF.id,
    howMuchDataC.id,
    bigEnterprise.id,
    buyOrBringPhone.id,
    choosePhoneOs.id,
    chooseBrands.id,
    choosePhoneSize.id,
    choosePhoneCamera.id,
    choosePhoneMemory.id,
    choosePhoneFromList.id,
  ],
  steps: [
    provincesStep,
    currentProviderMobile,
    howManyCallingMinutesF,
    howMuchDataC,
    sliderData,
    bigEnterprise,
    buyOrBringPhone,
    choosePhoneOs,
    chooseBrands,
    chooseBrandsAndroid,
    chooseBrandsProprietary,
    choosePhoneSize,
    choosePhoneCamera,
    choosePhoneMemory,
    choosePhoneFromList,
  ],
  weight: 0,
}

export const mobileScenarioG: Scenario = {
  id: 'mobile-g',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.MOBILE,
  version: '1',
  milestones: [
    provincesStep.id,
    currentProviderMobile.id,
    howManyCallingMinutesE.id,
    coverage.id,
    howMuchDataC.id,
    buyOrBringPhone.id,
    choosePhoneOs.id,
    chooseBrands.id,
    choosePhoneSize.id,
    choosePhoneCamera.id,
    choosePhoneMemory.id,
    chooseWifiCalling.id,
    choosePhoneFromList.id,
  ],
  steps: [
    provincesStep,
    currentProviderMobile,
    howManyCallingMinutesE,
    coverage,
    howMuchDataC,
    sliderDataG,
    buyOrBringPhone,
    choosePhoneOs,
    chooseBrands,
    chooseBrandsAndroid,
    chooseBrandsProprietary,
    choosePhoneSize,
    choosePhoneCamera,
    choosePhoneMemory,
    chooseWifiCalling,
    choosePhoneFromList,
  ],
  weight: 0,
}

export const mobileScenarioH: Scenario = {
  id: 'mobile-h',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.MOBILE,
  version: '1',
  milestones: [
    provincesStep.id,
    currentProviderMobile.id,
    howManyCallingMinutesE.id,
    coverage.id,
    howMuchDataC.id,
    buyOrBringPhone.id,
    choosePhoneOs.id,
    chooseBrands.id,
    choosePhoneSize.id,
    choosePhoneCamera.id,
    choosePhoneMemory.id,
    chooseWifiCalling.id,
    choosePhoneFromList.id,
  ],
  steps: [
    provincesStep,
    currentProviderMobile,
    howManyCallingMinutesE,
    coverage,
    howMuchDataC,
    sliderDataG,
    buyOrBringPhone,
    choosePhoneOs,
    chooseBrands,
    chooseBrandsAndroid,
    chooseBrandsProprietary,
    choosePhoneSize,
    choosePhoneCamera,
    choosePhoneMemory,
    chooseWifiCalling,
    choosePhoneFromList,
  ],
  weight: 0,
}

export const mobileScenarioI: Scenario = {
  id: 'mobile-i',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.MOBILE,
  version: '1',
  milestones: [
    provincesStepI.id,
    bigEnterprise2.id,
    currentProviderMobile.id,
    howManyCallingMinutesE.id,
    coverage.id,
    howMuchDataC.id,
    buyOrBringPhone.id,
    choosePhoneOs.id,
    chooseBrands.id,
    choosePhoneSize.id,
    choosePhoneCamera.id,
    choosePhoneMemory.id,
    chooseWifiCalling.id,
    choosePhoneFromList.id,
  ],
  steps: [
    provincesStepI,
    bigEnterprise2,
    currentProviderMobile,
    howManyCallingMinutesE,
    coverage,
    howMuchDataC,
    sliderDataG,
    buyOrBringPhone,
    choosePhoneOs,
    chooseBrands,
    chooseBrandsAndroid,
    chooseBrandsProprietary,
    choosePhoneSize,
    choosePhoneCamera,
    choosePhoneMemory,
    chooseWifiCalling,
    choosePhoneFromList,
  ],
  weight: 0,
}

export const mobileScenarioJ: Scenario = {
  id: 'mobile-j',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.MOBILE,
  version: '1',
  milestones: [
    provincesStepI.id,
    bigEnterprise2.id,
    currentProviderMobile.id,
    howManyCallingMinutesE.id,
    coverage.id,
    howMuchDataC.id,
    buyOrBringPhone.id,
    choosePhoneOs.id,
    chooseBrands.id,
    choosePhoneSize.id,
    choosePhoneCamera.id,
    choosePhoneMemory.id,
    chooseWifiCalling.id,
    choosePhoneFromList.id,
  ],
  steps: [
    provincesStepI,
    bigEnterprise2,
    currentProviderMobile,
    howManyCallingMinutesE,
    coverage,
    howMuchDataC,
    sliderDataG,
    buyOrBringPhone,
    choosePhoneOs,
    chooseBrands,
    chooseBrandsAndroid,
    chooseBrandsProprietary,
    choosePhoneSize,
    choosePhoneCamera,
    choosePhoneMemory,
    chooseWifiCalling,
    choosePhoneFromList,
  ],
  weight: 0,
}

export const mobileScenarioK: Scenario = {
  id: 'mobile-k',
  initialStep: Steps.BUSINESS_OR_NOT_MOBILE,
  type: ScenarioType.MOBILE,
  version: '1',
  milestones: [
    businessOrNotMobile.id,
    provincesStep.id,
    currentProviderMobile.id,
    howManyCallingMinutesE.id,
    coverage.id,
    howMuchDataC.id,
    buyOrBringPhone.id,
    choosePhoneOs.id,
    chooseBrands.id,
    choosePhoneSize.id,
    choosePhoneCamera.id,
    choosePhoneMemory.id,
    chooseWifiCalling.id,
    choosePhoneFromList.id,
  ],
  steps: [
    businessOrNotMobile,
    provincesStep,
    currentProviderMobile,
    howManyCallingMinutesE,
    coverage,
    howMuchDataC,
    sliderDataG,
    buyOrBringPhone,
    choosePhoneOs,
    chooseBrands,
    chooseBrandsAndroid,
    chooseBrandsProprietary,
    choosePhoneSize,
    choosePhoneCamera,
    choosePhoneMemory,
    chooseWifiCalling,
    choosePhoneFromList,
  ],
  weight: 0,
}

export const mobileScenarioL: Scenario = {
  id: 'mobile-l',
  initialStep: Steps.BUSINESS_OR_NOT_MOBILE,
  type: ScenarioType.MOBILE,
  version: '1',
  milestones: [
    businessOrNotMobile.id,
    provincesStep.id,
    currentProviderMobile.id,
    howManyCallingMinutesE.id,
    coverage.id,
    howMuchDataC.id,
    buyOrBringPhone.id,
    choosePhoneOs.id,
    chooseBrands.id,
    choosePhoneSize.id,
    choosePhoneCamera.id,
    choosePhoneMemory.id,
    chooseWifiCalling.id,
    choosePhoneFromList.id,
  ],
  steps: [
    businessOrNotMobile,
    provincesStep,
    currentProviderMobile,
    howManyCallingMinutesE,
    coverage,
    howMuchDataC,
    sliderDataG,
    buyOrBringPhone,
    choosePhoneOs,
    chooseBrands,
    chooseBrandsAndroid,
    chooseBrandsProprietary,
    choosePhoneSize,
    choosePhoneCamera,
    choosePhoneMemory,
    chooseWifiCalling,
    choosePhoneFromList,
  ],
  weight: 0,
}

export const mobileScenarioM: Scenario = {
  id: 'mobile-m',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.MOBILE,
  version: '1',
  milestones: [
    provincesStep.id,
    currentProviderMobile.id,
    howManyCallingMinutesE.id,
    coverage.id,
    howMuchDataC.id,
    buyOrBringPhone.id,
    choosePhoneOs.id,
    chooseBrands.id,
    choosePhoneSize.id,
    choosePhoneCamera.id,
    choosePhoneMemory.id,
    chooseWifiCalling.id,
    choosePhoneFromList.id,
  ],
  steps: [
    provincesStep,
    currentProviderMobile,
    howManyCallingMinutesE,
    coverage,
    howMuchDataC,
    sliderDataG,
    buyOrBringPhone,
    choosePhoneOs,
    chooseBrands,
    chooseBrandsAndroid,
    chooseBrandsProprietary,
    choosePhoneSize,
    choosePhoneCamera,
    choosePhoneMemory,
    chooseWifiCalling,
    choosePhoneFromList,
  ],
  weight: 0,
}

export const mobileScenarioN: Scenario = {
  id: 'mobile-n',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.MOBILE,
  version: '1',
  milestones: [
    provincesStep.id,
    currentProviderMobile.id,
    howManyCallingMinutesE.id,
    coverage.id,
    howMuchDataC.id,
    buyOrBringPhone.id,
    choosePhoneOs.id,
    chooseBrands.id,
    choosePhoneSize.id,
    choosePhoneCamera.id,
    choosePhoneMemory.id,
    chooseWifiCalling.id,
    choosePhoneFromList.id,
  ],
  steps: [
    provincesStep,
    currentProviderMobile,
    howManyCallingMinutesE,
    coverage,
    howMuchDataC,
    sliderDataG,
    buyOrBringPhone,
    choosePhoneOs,
    chooseBrands,
    chooseBrandsAndroid,
    chooseBrandsProprietary,
    choosePhoneSize,
    choosePhoneCamera,
    choosePhoneMemory,
    chooseWifiCalling,
    choosePhoneFromList,
  ],
  weight: 0,
}

export const mobileScenarioO: Scenario = {
  id: 'mobile-o',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.MOBILE,
  version: '1',
  milestones: [
    provincesStep.id,
    currentProviderMobile.id,
    currentProviderInternetMobile.id,
    howManyCallingMinutesE.id,
    coverage.id,
    howMuchDataD.id,
    buyOrBringPhone.id,
    choosePhoneOs.id,
    chooseBrands.id,
    choosePhoneSizeO.id,
    // choosePhoneCamera.id,
    choosePhoneMemory.id,
    chooseWifiCalling.id,
    choosePhoneFromList.id,
  ],
  steps: [
    provincesStep,
    currentProviderMobile,
    currentProviderInternetMobile,
    howManyCallingMinutesE,
    coverage,
    howMuchDataD,
    androidApp,
    sliderDataG,
    buyOrBringPhone,
    choosePhoneOs,
    chooseBrands,
    chooseBrandsAndroid,
    chooseBrandsProprietary,
    choosePhoneSizeO,
    // choosePhoneCamera,
    choosePhoneMemory,
    chooseWifiCalling,
    choosePhoneFromList,
  ],
  weight: 1,
}

export const mobileScenarioP: Scenario = {
  id: 'mobile-p',
  initialStep: Steps.PROVINCE,
  type: ScenarioType.MOBILE,
  version: '1',
  milestones: [
    provincesStep.id,
    currentProviderMobile.id,
    currentProviderInternetMobile.id,
    howManyCallingMinutesE.id,
    coverage.id,
    howMuchDataD.id,
    buyOrBringPhone.id,
    choosePhoneOs.id,
    chooseBrands.id,
    choosePhoneSizeO.id,
    // choosePhoneCamera.id,
    choosePhoneMemory.id,
    chooseWifiCalling.id,
    choosePhoneFromList.id,
  ],
  steps: [
    provincesStep,
    currentProviderMobile,
    currentProviderInternetMobile,
    howManyCallingMinutesE,
    coverage,
    howMuchDataD,
    androidApp,
    sliderDataG,
    buyOrBringPhone,
    choosePhoneOs,
    chooseBrands,
    chooseBrandsAndroid,
    chooseBrandsProprietary,
    choosePhoneSizeO,
    // choosePhoneCamera,
    choosePhoneMemory,
    chooseWifiCalling,
    choosePhoneFromList,
  ],
  weight: 1,
}
